<template>
    <div class="main-page">
        <Header :isNavCurrent="0" @videoShowF="videoShowF" />
        <div class="page0">
            <picture>
                <source media="(orientation: portrait) and (max-width:768px)" :srcset="pageData.company.image.wap" />
                <img class="img" :src="pageData.company.image.pc" data-object-fit="cover" />
            </picture>
        </div>
        <div class="page1" v-html="pageData.company.desc"> </div>
        <div class="page2">
            <div class="title">{{pageData.business.title}}</div>
            <div class="img0">
                <picture>
                    <source media="(orientation: portrait) and (max-width:768px)" :srcset="pageData.business.image.wap" />
                    <img class="img" :src="pageData.business.image.pc" data-object-fit="cover" />
                </picture>
            </div>
            <div class="desc" v-html="pageData.business.desc"></div>
        </div>
        <div class="page3">
            <div class="ul">
                <div class="li" v-for="(item,idx) in pageData.business.leftcon" :key="idx" >
                    <div class="title">
                        <span class="circle">•</span>{{item.title}}
                    </div>
                    <div class="desc" v-html="item.desc">  </div>
                </div> 
            </div>
            <div class="ul right">
                <div class="li"  v-for="(item,idx) in pageData.business.rightcon" :key="idx"  >
                    <div class="title">
                        <span class="circle">•</span>{{item.title}}
                    </div>
                    <div class="desc" v-html="item.desc"> </div>
                </div> 
            </div>
        </div>
        <div class="page4">
            <div class="title">
                <div class="showpc" v-html="pageData.qualification.title.pc" ></div>
                <div class="showm" v-html="pageData.qualification.title.wap"></div>
            </div>
            <picture>
                <source media="(orientation: portrait) and (max-width:768px)" :srcset="pageData.qualification.image.wap" />
                <img class="img" :src="pageData.qualification.image.pc" data-object-fit="cover" />
            </picture>
 
        </div>
        <div class="page5">
            <div class="title" v-html="pageData.industry.title"></div>
            <div class="desc"  v-html="pageData.industry.con0.desc"></div>
            <div class="img0">
                <picture>
                    <source media="(orientation: portrait) and (max-width:768px)" :srcset="pageData.industry.con0.image.wap" />
                    <img class="img" :src="pageData.industry.con0.image.pc" data-object-fit="cover" />
                </picture>
            </div>
        </div>
        <div class="page6">
            <div class="desc"  v-html="pageData.industry.con1.desc"> </div>
            <div class="img0">
                <picture>
                    <source media="(orientation: portrait) and (max-width:768px)" :srcset="pageData.industry.con1.image.wap" />
                    <img class="img" :src="pageData.industry.con1.image.pc" data-object-fit="cover" />
                </picture>
            </div>
            <div class="desc desc1"  v-html="pageData.industry.con2.desc"> </div>
            <div class="img1">
                <picture>
                    <source media="(orientation: portrait) and (max-width:768px)" :srcset="pageData.industry.con2.image.wap" />
                    <img class="img" :src="pageData.industry.con2.image.pc" data-object-fit="cover" />
                </picture>
            </div>
        </div>
        <div class="page7">
            <div class="title" v-html="pageData.advantage.title"></div>
            <div class="con0">
                <div class="t0">
                    {{pageData.advantage.con0.title}}
                    <div class="icon"></div>
                </div>
                <div class="desc" v-html="pageData.advantage.con0.desc" ></div>
            </div>
            <div class="con1">
                <div class="icon"></div>
                <div class="t0">{{pageData.advantage.con1.title}}</div>
                <div class="desc" v-html="pageData.advantage.con1.desc" ></div>
            </div>
            <div class="con0 con2">
                <div class="t0">
                    {{pageData.advantage.con2.title}}
                    <div class="icon"></div>
                </div>
                <div class="desc" v-html="pageData.advantage.con2.desc" ></div>
            </div>
            <div class="con1 con3">
                <div class="icon"></div>
                <div class="t0">{{pageData.advantage.con3.title}}</div>
                <div class="desc" v-html="pageData.advantage.con3.desc"></div>
            </div>
        </div>
        <div class="page8">
            <div class="title">{{pageData.cooperation.title}}</div>
            <div class="summary">
                <div class="showpc" v-html="pageData.cooperation.desc.pc" >  </div>
                <div class="showm" v-html="pageData.cooperation.desc.wap" > </div>
            </div>
            <div class="ulcon">
                <div class="ul">
                    <div class="li" v-for="(item,idx) in pageData.cooperation.list" :key="idx">
                        <div class="t0" v-html="item.title" ></div>
                        <div class="t1" v-html="item.desc"  > </div>
                    </div> 
                </div>
            </div>
        </div>
        <div class="page9" id="page9">
            <div class="title"  >{{pageData.contact.title}}</div>
            <div class="ullist">
                <div class="li" v-for="(item,idx) in pageData.contact.list" :key="idx" >
                    <div class="t0">{{item.title}}</div>
                    <div class="t1">{{item.tel}}</div>
                </div> 
            </div>
            <div class="ullist2">
                <div class="tel">{{pageData.contact.tel}}</div>
                <div class="email">{{pageData.contact.email}}</div>
                <div class="address">{{pageData.contact.address}}</div>
            </div>
        </div>
        <div class="page10">
            <div class="leftcon">
                <div class="summary" >
                    {{pageData.commitment.leftcon.title}}
                </div>
                <div class="ul">
                    <div class="li" v-for="(item,idx) in pageData.commitment.leftcon.list" :key="idx">
                        <div class="t0">
                            <span class="circle">•</span>{{item.title}}
                        </div>
                        <div class="t1" v-html="item.desc"></div>
                    </div> 
                </div>
            </div>
            <div class="rightcon">
                <div class="btxt">
                    <picture>
                        <source media="(orientation: portrait) and (max-width:768px)" :srcset="pageData.commitment.rightcon.image.wap" />
                        <img class="img" :src="pageData.commitment.rightcon.image.pc" data-object-fit="cover" />
                    </picture>
                </div>
                <div class="desc" v-html="pageData.commitment.rightcon.desc"></div>
            </div>
        </div>
        <div class="page11">
            <div class="title">{{pageData.customer.title}}</div>
            <div class="img10">
                <picture>
                    <source media="(orientation: portrait) and (max-width:768px)" :srcset="pageData.customer.image.wap" />
                    <img class="img" :src="pageData.customer.image.pc" data-object-fit="cover" />
                </picture>
            </div>
        </div>
        <Footer />
        <floatIcon />
    </div>
</template>
<script>
import Header from '@/components/header'
import Footer from '@/components/footer'
import floatIcon from '@/components/floatIcon.vue'
export default {
    name: 'Index',
    components: {
        Header,
        Footer,
        floatIcon
    },
    data() {
        return {
            pageData: {
                company: {
                    image: {
                        pc: 'https://www.hudongpai.com/img/banner.609701c3.jpg',
                        wap: 'https://www.hudongpai.com/img/banner_m.428a40fd.jpg'
                    },
                    desc:
                        '<p >互动派科技股份有限公司是一家<span  class="red">抖音、小红书</span><span  class="bold">双平台官方授权一级广告代理商</span>，是少数拥有超10年线上营销服务经验的公司，团队规模数百人，<span  class="bold">累积各行业客户共近30000个，连续三年广告消耗规模超10亿元</span>。2016年挂牌新三板，2021年入选中国最佳数字营销公司TOP50强，2023年获得国家级专精特新小巨人企业荣誉，系中国数字营销一级广告企业，<span  class="bold">广州市广告行业协会理事单位，广州4A协会会员</span>。互动派屡获行业权威大奖，如<span  class="red">金鼠标奖、金触点奖、国际麒麟奖、TMA移动数字营销大奖、IAI国际广告奖、ADMEN国际大奖，以及字节跳动巨量引擎共擎奖等。</span></p><p >互动派助力品牌在多个平台阵地<span  class="red">“被看见、被喜欢、被选择”</span>，依托官方授权资质与专业实力，提供从策划到落地执行的全流程服务，<span  class="red">做到真正数据驱动的品效合一</span>。<span  class="bold">服务头部品牌有：</span>宝洁、蒙牛、统一、麦当劳、肯德基、屈臣氏、汤臣倍健、合生元、骆驼服饰、家乐福、南方航空、海尔集团、中国农业银行、中国建设银行、中国联通、中国移动等世界五百强企业或行业知名企业。</p>'
                },
                business: {
                    title: '业务范畴',
                    image: {
                        pc: 'https://www.hudongpai.com/img/page2_img0.0b6570c1.png',
                        wap: 'https://www.hudongpai.com/img/page2_img0_m.98aed395.png'
                    },
                    desc: '<span  class="bold">围绕抖音和小红书一级代理商身份结合各媒体平台专业能力</span>，协助客户在各大主流平台线上推广，实现大数据驱动的<span  class="bold">精准营销获客及销售高效转化和品牌曝光</span>。',

                    leftcon: [
                        {
                            title: '平台广告投',
                            desc: '作为官方代理商，互动派直接对接抖音（巨量千川，巨量AD，巨量本地推）及小红书（聚光，乘风，CID）官方开户端口，享受官方专属投放策略及政策，结合在行业沉淀的策略及服务经验，根据客户不同目标（卖货、获客、涨粉）精准调控，让每一分广告费花到实处。'
                        },
                        {
                            title: '内容创意制作',
                            desc: '针对客户具体产品及服务，专门打造符合平台调性且符合官方合规标准的内容——抖音的吸睛短视频、剧情段子、直播脚本，小红书的真实测评、干货笔记、场景化种草文，凭借专业创作资质保障内容质量，让用户愿意看、主动转、下单、复购等，同时在熟悉平台基础下减少审核驳回风险。'
                        }
                    ],
                    rightcon: [
                        {
                            title: '达人合作对接',
                            desc: '通过抖音星图、小红书蒲公英等官方平台，依托代理商资源优势+行业口碑，帮你匹配更适配的达人（从头部红人、垂类达人、多类型素人等），<br />全程跟进合作流程，确保推广内容真实自然，还能享受官方背书的合作保障。'
                        },
                        {
                            title: '数据优化复盘',
                            desc: '用官方工具后台（如：巨量云图、小红书灵犀平台等）结合多个项目沉淀的方案论，实时对核心数据进行根据优化（曝光量、点击率、成交量等），<br />定期提供报表反馈，动态调整投放方向，让效果持续升级。'
                        },
                        {
                            title: 'AI智能客服应用',
                            desc: '针对以线索经营为目标的B端客户，互动派紧跟着平台趋势，推进私信链路+深度转化目标，通过有效接入自研AI智能客服工具，<br />有效为客户降低客服人力成本并降低前端获客成本，最终实现终转的有效率提升及转化成本降低。'
                        }
                    ]
                },
                qualification: {
                    title: {
                        pc: '资质认证+行业大奖 双背书的硬核实力',
                        wap: '资质认证+行业大奖<br />双背书的硬核实力'
                    },
                    image: {
                        pc: 'https://www.hudongpai.com/uploads/images/qualification_img0.png',
                        wap: 'https://www.hudongpai.com/uploads/images/qualification_img0_m.png'
                    }
                },
                industry: {
                    title: '行业大奖 实战效果获认可',
                    con0: {
                        desc: '<span class="bold">综合实力奖项：</span >近两年荣获数字营销类国家一级广告企业证书及粤港澳数字资产业创新卓越品牌奖，用营销实战经验获得行业认可。',
                        image: {
                            pc: 'https://www.hudongpai.com/img/page5_img0.0f88fffb.png',
                            wap: 'https://www.hudongpai.com/img/page5_img0_m.858d3fca.png'
                        }
                    },
                    con1: {
                        desc: '<span class="bold">案例类奖项：</span  >凭SKG小红书种草项目、广州红幸福城抖音品牌营销项目等，分获包括金触点银奖、IAI优秀奖、ADMEN国际大赏实战金奖、金匠奖营销铜奖、麒麟国际广告奖银奖等多个营销案例大奖”，用真实项目成果验证服务能力。',
                        image: {
                            pc: 'https://www.hudongpai.com/img/page6_img0.6544d09a.png',
                            wap: 'https://www.hudongpai.com/img/page6_img0_m.c2caf6f0.png'
                        }
                    },
                    con2: {
                        desc: '<span class="bold">平台合作奖项：</span >荣获“巨量引擎生态业务全域经营产品共赢奖”及巨量引擎平台专项技术共建奖，得到媒体平台机构认证与同行的双重认可。',
                        image: {
                            pc: 'https://www.hudongpai.com/img/page6_img1.328bdcfa.png',
                            wap: 'https://www.hudongpai.com/img/page6_img1_m.ef1ed591.png'
                        }
                    }
                },
                advantage: {
                    title: '独特优势',
                    con0: {
                        title: '双重背书更放心：',
                        desc: '作为官方代理商，互动派直接对接抖音（巨量千川，巨量AD，巨量本地推）及小红书（聚光，乘风，CID）官方开户端口，享受官方专属投放策略及政策，结合在行业沉淀的策略及服务经验，根据客户不同目标（卖货、获客、涨粉）精准调控，让每一分广告费花到实处。'
                    },
                    con1: {
                        title: '资源政策双优先：',
                        desc: '享受平台专属绿色通道，节点大促（618、双11）可提前获取官方玩法攻略和流量扶持，广告审核、违规申诉速度更快；同时可享受官方阶梯返点政策，结合资质对应的优惠权限，有效降低营销成本。'
                    },
                    con2: {
                        title: '专业团队更靠谱：',
                        desc: '运营及创意团队核心成员均通过平台官方认证培训，且有获奖案例操盘经验，熟悉平台算法规则、平台素材动向、最新政策及行业趋势，能提供更精准的策略建议及更适合的投流素材，避免因不懂规则导致的投放浪费。'
                    },
                    con3: {
                        title: '定制方案更精准：',
                        desc: '不套用统一模板，结合品牌特点、目标客户、预算范围，融入获奖案例的成功经验，给出定制化方案，比如线下门店侧重抖音本地推+小红书同城笔记，电商品牌主攻千川投放+达人带货，精准匹配需求。'
                    }
                },
                cooperation: {
                    title: '合作流程',
                    desc: {
                        pc: '为确保合作目标的精准达成与高效推进，我们建立了一套标准化、透明化的四阶段服务流程，具体如下：',
                        wap: '为确保合作目标的精准达成与高效推进，<br />我们建立了一套标准化、透明化的四阶段服务流程，具体如下：'
                    },
                    list: [
                        {
                            title: '第一阶段：需求诊断与目标对齐',
                            desc: '明确营销推广的核心目标（例如：月度商品销售XX件、有效销售线索收集XX条等）、总体预算框架与预期时间节点。在此基础上，互动派将协助客户梳理并确认清晰、可量化的项目方向与关键绩效指标。'
                        },
                        {
                            title: '第二阶段：定制化方案与确认',
                            desc: '在明确需求后，互动派将在3个工作日内，给客户提交一份完整的专属营销策划方案。该方案将详尽阐述内容创意形式、媒介投放渠道策略、达人资源匹配建议、预算精细化分配计划以及可申请的官方平台政策支持。同时，将提供过往相关的行业成功案例及资质证明供参考。方案需经客户书面确认后，方可进入执行阶段。'
                        },
                        {
                            title: '第三阶段：全链路执行与实时优化',
                            desc: '项目启动后，互动派团队将负责全流程的落地执行，包括但不限于创意内容制作、达人矩阵沟通与协调、广告流量的精准投放与管理等。执行期间，互动派将保持高频进度同步，并依托与官方平台的紧密合作渠道，快速响应、处理各类突发问题（如内容审核、流量波动等），确保项目平稳高效运行。'
                        },
                        {
                            title: '第四阶段：效果复盘与长期价值交付',
                            desc: '项目服务周期结束后，互动派将提供一份全面的数据复盘与策略分析报告，系统总结项目亮点、目标达成情况以及可优化的空间。互动派将同步落实官方平台政策返点，确保客户利益最大化。珍视长期合作关系，持续合作的客户将有机会升级至更高级别的专属服务体系，享受更多权益。'
                        }
                    ]
                },
                contact: {
                    title: '联系方式',
                    list: [
                        {
                            title: '抖音本地推/小红书效果合作',
                            tel: '许经理 13250235410'
                        },
                        { title: '抖音千川合作', tel: '朱经理 13660424278' },
                        { title: '小红书种草合作', tel: '刘经理 18922228633' },
                        { title: '品牌业务合作', tel: '黄经理 13929520153' },
                        { title: '公司业务合作', tel: '张总 18702090299' }
                    ],
                    tel: '电话：020-38891740',
                    email: '邮箱：marketing@hudongpai.com',
                    address: '地址：广州市天河区兴民路222号天盈广场西塔15F'
                },
                commitment: {
                    leftcon: {
                        title: '互动派洞察到，企业在数字营销中常面临以下核心挑战：',
                        list: [
                            {
                                title: '启动顾虑：',
                                desc: '有意布局线上推广，却因对非正规渠道的可靠性质疑而却步，难以在抖音、小红书等多平台间做出科学的渠道选择与投放决策。'
                            },
                            {
                                title: '执行困境：',
                                desc: '自主创作的内容频繁面临审核问题；难以甄别与链接优质的达人资源；广告投放效果未达预期，却缺乏专业诊断以定位根本原因。'
                            },
                            {
                                title: '成本与资源焦虑',
                                desc: '期望优化营销成本结构，获取更优势的官方政策与高阶服务支持，但缺乏直接的官方对接路径与专业指导。'
                            },
                            {
                                title: '合作信任需求',
                                desc: '高度重视服务商的综合实力，期待其具备官方资质、权威行业奖项等硬性背书，以保障合作的专业性与安全性，规避潜在风险。'
                            }
                        ]
                    },
                    rightcon: {
                        image: {
                            pc: 'https://www.hudongpai.com/img/page10_img0.414869a0.png',
                            wap: 'https://www.hudongpai.com/img/page10_img0.414869a0.png'
                        },
                        desc: '无论企业是初涉平台广告，还是寻求现有推广策略的优化与突破，作为拥有“官方授权、资质认证、行业获奖”三重保障的抖音与小红书广告服务商，我们始终致力于成为您值得信赖的长期营销伙伴。请将专业的数字营销事务托付给我们，您可全心专注于产品优化与客户服务，而将流量增长与效果转化的关键环节，交予互动派来实现。'
                    }
                },
                customer: {
                    title: '合作客户',
                    image: {
                        pc: 'https://www.hudongpai.com/img/kehu_0.2e610a50.png',
                        wap: 'https://www.hudongpai.com/img/kehu_0_m.4a6543c8.png'
                    }
                }
            },
            isNavCurrent: 0
        }
    },
    async created() {
        // 测试环境
        if (window.location.href.indexOf('localhost') >= 0) {
            var res = await this.$post('/test/getPage', { id: 1 })
            var pageData = res.data
        } else {
            var pageData = orginalJsonData.content
        }
        this.pageData = pageData
    },
    mounted() {},
    beforeDestroy() {},
    destroyed() {},
    methods: {
        mainTouchStart() {},
        videoShowF(value) {}
    }
}
</script>
<style scoped lang="scss">
.main-page {
    width: 100%;
    overflow-x: hidden;
    background-color: #fff;
    .bold {
        font-weight: 700;
    }
    .showpc {
        display: block;
        @media screen and (max-width: 768px) {
            display: none;
        }
    }
    .showm {
        display: none;
        @media screen and (max-width: 768px) {
            display: block;
        }
    }
    .page0 {
        width: 100%;
        height: 4.98rem;
        .img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        @media screen and (max-width: 768px) {
            height: 3.06rem;
        }
    }
    .page1 {
        padding: 0.94rem 1.68rem;
        font-size: 0.29rem;
        line-height: 1.5;
        color: #000000;
        @media screen and (max-width: 768px) {
            padding: 0.4rem 0.6rem;
            font-size: 0.18rem;
        }
        >>> p {
            text-indent: 2em;
            text-align: justify;
        }
        >>> .red {
            color: #e60012;
            font-weight: 700;
        }
        >>> .bold {
            font-weight: 700;
        }
    }
    .page2 {
        background: url(../../assets/index0228/page2_bg.jpg) no-repeat;
        background-size: 100% 100%;
        padding: 0.65rem 1.7rem;
        color: #fff;
        @media screen and (max-width: 768px) {
            background: url(../../assets/index0228/page2_bg_m.jpg) no-repeat;
            background-size: 100% 100%;
            padding: 0.4rem 0.6rem;
        }
        .title {
            font-size: 0.61rem;
            font-weight: 700;
            text-align: center;
            line-height: 1.2;
            @media screen and (max-width: 768px) {
                font-size: 0.38rem;
            }
        }
        .img0 {
            width: 13.32rem;
            height: 1.26rem;
            margin: 0.7rem auto;
            .img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
            @media screen and (max-width: 768px) {
                width: 6.19rem;
                height: 0.6rem;
                margin: 0.3rem auto;
            }
        }
        .desc {
            text-indent: 2em;
            font-size: 0.29rem;
            line-height: 1.5;
            @media screen and (max-width: 768px) {
                font-size: 0.18rem;
            }
        }
    }
    .page3 {
        background: url(../../assets/index0228/page3_bg.jpg) no-repeat;
        background-size: 100% 100%;
        padding: 1rem 1.7rem;
        color: #fff;
        @media screen and (max-width: 768px) {
            background: url(../../assets/index0228/page3_bg_m.jpg) no-repeat;
            background-size: 100% 100%;
            padding: 0.5rem 0.6rem;
        }
        .ul {
            display: block;
            padding-bottom: 1px;
            &.right {
                .li {
                    text-align: right;
                    &:first-child {
                        margin-top: 0.8rem;
                        @media screen and (max-width: 768px) {
                            margin-top: 0.4rem;
                        }
                    }
                    &:last-child {
                        .desc {
                            margin-bottom: 0;
                        }
                    }
                }
            }
            .li {
                .title {
                    text-indent: 0.5em;
                    color: #e60012;
                    font-size: 0.29rem;
                    line-height: 1.2;
                    @media screen and (max-width: 768px) {
                        font-size: 0.21rem;
                    }
                    .circle {
                        padding-right: 0.15rem;
                        @media screen and (max-width: 768px) {
                            padding-right: 0.15rem;
                        }
                    }
                }
                .desc {
                    line-height: 2;
                    font-size: 0.24rem;
                    margin: 0.2rem 0 0.8rem 0;
                    @media screen and (max-width: 768px) {
                        font-size: 0.17rem;
                        margin: 0.12rem 0 0.34rem 0;
                    }
                }
            }
        }
    }
    .page4 {
        background-color: #fff;
        padding: 0.8rem 0rem 1.76rem 0rem;
        @media screen and (max-width: 768px) {
            padding: 0.4rem 0rem 0.6rem 0rem;
        }
        .title {
            font-size: 0.62rem;
            color: #e60012;
            font-weight: 700;
            text-align: center;
            line-height: 1.2;
            margin-bottom: 0.6rem;
            @media screen and (max-width: 768px) {
                font-size: 0.43rem;
                margin-bottom: 0.4rem;
            }
        }
        .img {
            display: block;
            width: 17.45rem;
            height: auto;
            margin: 0 auto 0rem auto;
            @media screen and (max-width: 768px) {
                width: 100%;
                margin: 0 auto 0rem auto;
            }
        }
    }
    .page5 {
        background: url(../../assets/index0228/page5_bg.jpg) no-repeat;
        background-size: 100% 100%;
        padding: 0.74rem 1.8rem 1.25rem 1.8rem;
        color: #fff;
        @media screen and (max-width: 768px) {
            background: url(../../assets/index0228/page5_bg_m.jpg) no-repeat;
            background-size: 100% 100%;
            padding: 0.4rem 0.64rem 0.5rem 0.4rem;
        }
        .title {
            font-size: 0.61rem;
            font-weight: bold;
            text-align: center;
            margin-bottom: 0.6rem;
            @media screen and (max-width: 768px) {
                font-size: 0.42rem;
                margin-bottom: 0.3rem;
            }
        }
        .desc {
            font-size: 0.29rem;
            line-height: 1.5;
            >>> .bold {
                font-weight: 700;
            }
            @media screen and (max-width: 768px) {
                font-size: 0.19rem;
            }
        }
        .img0 {
            width: 14.62rem;
            height: 5.17rem;
            margin-top: 0.8rem;
            .img {
                width: 100%;
                height: 100%;
                display: block;
                object-fit: contain;
            }
            @media screen and (max-width: 768px) {
                width: 6.02rem;
                height: 2.29rem;
                margin-top: 0.3rem;
            }
        }
    }

    .page6 {
        padding: 0.9rem 1.7rem;
        @media screen and (max-width: 768px) {
            padding: 0.4rem 0.65rem;
        }
        .desc {
            font-size: 0.29rem;
            color: #e60012;
            line-height: 1.5;
            @media screen and (max-width: 768px) {
                font-size: 0.19rem;
            }
            >>> .bold {
                font-weight: 700;
            }
        }
        .img0 {
            width: 15.92rem;
            margin: 0.6rem 0 0.9rem 0;
            .img {
                width: 100%;
                display: block;
                object-fit: contain;
            }
            @media screen and (max-width: 768px) {
                width: 6.2rem;
                margin: 0.2rem 0 0.5rem 0;
            }
        }
        .img1 {
            width: 13.76rem;
            margin: 0.6rem auto 0.4rem auto;
            .img {
                width: 100%;
                display: block;
                object-fit: contain;
            }
            @media screen and (max-width: 768px) {
                width: 5.38rem;
                margin: 0.3rem auto 0.1rem auto;
            }
        }
    }
    .page7 {
        padding: 0.9rem 0rem;
        @media screen and (max-width: 768px) {
            padding: 0 0 0.6rem 0rem;
        }
        .title {
            font-size: 0.61rem;
            font-weight: bold;
            text-align: center;
            margin-bottom: 0.8rem;
            color: #e60012;
            line-height: 1.2;
            @media screen and (max-width: 768px) {
                font-size: 0.43rem;
                margin-bottom: 0.25rem;
            }
        }
        .con0 {
            background-color: #e60012;
            padding: 0.55rem 1.8rem;
            @media screen and (max-width: 768px) {
                padding: 0.2rem 0.7rem;
            }
            .t0 {
                font-size: 0.29rem;
                color: #000000;
                font-weight: 700;
                line-height: 1;
                margin-bottom: 0.36rem;
                position: relative;
                width: fit-content;
                @media screen and (max-width: 768px) {
                    font-size: 0.21rem;
                    margin-bottom: 0.12rem;
                }
                .icon {
                    width: 1.24rem;
                    height: 1.39rem;
                    position: absolute;
                    right: -1.24rem;
                    top: -1rem;
                    background: url(../../assets/index0228/page7_img0.png) no-repeat;
                    background-size: contain;
                    z-index: 1;
                    @media screen and (max-width: 768px) {
                        width: 0.49rem;
                        height: 0.55rem;
                        position: absolute;
                        right: -0.49rem;
                        top: -0.3rem;
                        background: url(../../assets/index0228/page7_img0_m.png) no-repeat;
                        background-size: contain;
                    }
                }
            }
            .desc {
                font-size: 0.24rem;
                color: #fff;
                line-height: 1.5;
                @media screen and (max-width: 768px) {
                    font-size: 0.15rem;
                }
            }
            &.con2 {
                .t0 {
                    .icon {
                        width: 1.73rem;
                        height: 1.29rem;
                        position: absolute;
                        right: -1.74rem;
                        top: -0.74rem;
                        background: url(../../assets/index0228/page7_img2.png) no-repeat;
                        background-size: contain;
                        z-index: 1;
                        @media screen and (max-width: 768px) {
                            width: 0.68rem;
                            height: 0.49rem;
                            position: absolute;
                            right: -0.68rem;
                            top: -0.24rem;
                            background: url(../../assets/index0228/page7_img2.png) no-repeat;
                            background-size: contain;
                        }
                    }
                }
            }
        }
        .con1 {
            background-color: #000000;
            padding: 0.55rem 1.8rem;
            position: relative;
            @media screen and (max-width: 768px) {
                padding: 0.2rem 0.7rem;
            }
            .t0 {
                font-size: 0.29rem;
                color: #e60012;
                font-weight: 700;
                line-height: 1;
                margin-bottom: 0.36rem;
                position: relative;
                width: fit-content;
                @media screen and (max-width: 768px) {
                    font-size: 0.21rem;
                    margin-bottom: 0.12rem;
                }
            }
            .icon {
                width: 1.72rem;
                height: 1.24rem;
                position: absolute;
                right: 0.44rem;
                bottom: 0rem;
                background: url(../../assets/index0228/page7_img1.png) no-repeat;
                background-size: contain;
                z-index: 1;
                @media screen and (max-width: 768px) {
                    width: 0.68rem;
                    height: 0.49rem;
                    position: absolute;
                    right: 0.2rem;
                    bottom: 0rem;
                    background: url(../../assets/index0228/page7_img1_m.png) no-repeat;
                    background-size: contain;
                }
            }
            .desc {
                font-size: 0.24rem;
                color: #fff;
                line-height: 1.5;
                @media screen and (max-width: 768px) {
                    font-size: 0.15rem;
                }
            }
            &.con3 {
                .icon {
                    width: 1.54rem;
                    height: 1.73rem;
                    position: absolute;
                    right: 0.64rem;
                    top: -0.6rem;
                    background: url(../../assets/index0228/page7_img3.png) no-repeat;
                    background-size: contain;
                    z-index: 1;
                    @media screen and (max-width: 768px) {
                        width: 0.61rem;
                        height: 0.69rem;
                        position: absolute;
                        right: 0.69rem;
                        top: auto;
                        bottom: -0.2rem;
                        background: url(../../assets/index0228/page7_img3_m.png) no-repeat;
                        background-size: contain;
                    }
                }
            }
        }
    }
    .page8 {
        padding: 0.5rem 0;
        @media screen and (max-width: 768px) {
            padding: 0.1rem 0;
        }
        .title {
            font-size: 0.61rem;
            font-weight: bold;
            text-align: center;
            margin-bottom: 0.6rem;
            color: #e60012;
            line-height: 1.2;
            @media screen and (max-width: 768px) {
                font-size: 0.43rem;
                margin-bottom: 0.16rem;
            }
        }
        .summary {
            font-size: 0.29rem;
            margin-bottom: 0.8rem;
            color: #000000;
            line-height: 1.2;
            text-align: center;
            @media screen and (max-width: 768px) {
                font-size: 0.16rem;
                margin-bottom: 0.3rem;
            }
        }
        .ulcon {
            background: url(../../assets/index0228/page9_bg.jpg) no-repeat;
            background-size: 100% 100%;
            padding: 1.3rem 1.8rem;
            @media screen and (max-width: 768px) {
                background: url(../../assets/index0228/page9_bg_m.jpg) no-repeat;
                background-size: 100% 100%;
                padding: 0.4rem 0.7rem;
            }
            .ul {
                .li {
                    margin-bottom: 1rem;
                    @media screen and (max-width: 768px) {
                        margin-bottom: 0.35rem;
                    }
                    &:last-child {
                        margin-bottom: 0;
                    }
                    .t0 {
                        font-size: 0.29rem;
                        color: #010101;
                        line-height: 1.2;
                        margin-bottom: 0.2rem;
                        font-weight: 700;
                        @media screen and (max-width: 768px) {
                            font-size: 0.21rem;
                            margin-bottom: 0.1rem;
                        }
                    }
                    .t1 {
                        font-size: 0.24rem;
                        color: #fff;
                        line-height: 1.5;
                        @media screen and (max-width: 768px) {
                            font-size: 0.15rem;
                        }
                    }
                }
            }
        }
    }
    .page9 {
        padding: 0 0 0.5rem 0;
        @media screen and (max-width: 768px) {
            padding: 0.4rem 0 0.3rem 0;
        }
        .title {
            font-size: 0.61rem;
            font-weight: bold;
            text-align: center;
            margin-bottom: 0.4rem;
            color: #e60012;
            line-height: 1.2;
            @media screen and (max-width: 768px) {
                font-size: 0.43rem;
                margin-bottom: 0.2rem;
            }
        }
        .ullist {
            width: 13.6rem;
            margin: 0 auto;
            display: flex;
            flex-direction: row;
            justify-content: center;
            flex-wrap: wrap;
            margin-bottom: 0.45rem;
            @media screen and (max-width: 768px) {
                width: 7.5rem;
                margin: 0 auto;
                display: flex;
                flex-direction: row;
                justify-content: center;
                margin-bottom: 0.15rem;
                flex-wrap: wrap;
                justify-content: center;
            }
            .li {
                width: 3.5rem;
                padding: 0.15rem 0.23rem;
                margin: 0.38rem 0.35rem;
                box-sizing: border-box;
                text-align: center;
                background-color: #fef7f8;
                border-radius: 0.14rem;
                @media screen and (max-width: 768px) {
                    width: 2.16rem;
                    padding: 0.1rem 0.15rem;
                    border-radius: 0.06rem;
                    margin: 0 0.12rem 0.24rem 0.12rem;
                }
                .t0 {
                    color: #e60012;
                    line-height: 1.5;
                    font-size: 0.22rem;
                    font-weight: bold;
                    @media screen and (max-width: 768px) {
                        font-size: 0.13rem;
                    }
                }
                .t1 {
                    font-size: #0e0e0e;
                    line-height: 1.5;
                    font-size: 0.22rem;
                    @media screen and (max-width: 768px) {
                        font-size: 0.13rem;
                    }
                }
            }
        }
        .ullist2 {
            width: 14rem;
            margin: 0 auto;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            @media screen and (max-width: 768px) {
                width: 100%;
                justify-content: center;
                align-content: center;
                align-items: center;
            }
            .tel {
                background: url(../../assets/index0228/icon_tel.png) no-repeat left center;
                background-size: 0.22rem 0.24rem;
                font-size: 0.23rem;
                color: #363636;
                padding-left: 0.3rem;
                line-height: 1.5;
                @media screen and (max-width: 768px) {
                    background: url(../../assets/index0228/icon_tel.png) no-repeat left center;
                    background-size: 0.12rem 0.12rem;
                    font-size: 0.14rem;
                    padding-left: 0.17rem;
                    transform: scale(0.72);
                    transform-origin: center center;
                    word-wrap: normal;
                    word-break: keep-all;
                    white-space: nowrap;
                    margin-left: 0.2rem;
                }
            }
            .email {
                background: url(../../assets/index0228/icon_email.png) no-repeat left center;
                background-size: 0.22rem 0.16rem;
                font-size: 0.23rem;
                color: #363636;
                padding-left: 0.3rem;
                line-height: 1.5;
                @media screen and (max-width: 768px) {
                    background: url(../../assets/index0228/icon_email.png) no-repeat left center;
                    background-size: 0.14rem 0.12rem;
                    font-size: 0.14rem;
                    padding-left: 0.17rem;
                    transform: scale(0.72);
                    transform-origin: center center;
                    word-wrap: normal;
                    word-break: keep-all;
                    white-space: nowrap;
                    margin-left: -0.4rem;
                }
            }
            .address {
                background: url(../../assets/index0228/icon_address.png) no-repeat left center;
                background-size: 0.15rem 0.22rem;
                font-size: 0.23rem;
                color: #363636;
                padding-left: 0.3rem;
                line-height: 1.5;
                @media screen and (max-width: 768px) {
                    background: url(../../assets/index0228/icon_address.png) no-repeat left center;
                    background-size: 0.12rem 0.14rem;
                    font-size: 0.14rem;
                    padding-left: 0.17rem;
                    transform: scale(0.72);
                    transform-origin: center center;
                    word-wrap: normal;
                    word-break: keep-all;
                    white-space: nowrap;
                    margin-left: -0.65rem;
                }
            }
        }
    }
    .page10 {
        background-color: #e60012;
        padding: 1rem 1.7rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        color: #fff;
        @media screen and (max-width: 768px) {
            padding: 0.36rem 0.63rem;
            flex-direction: column;
        }
        .leftcon {
            width: 7rem;
            @media screen and (max-width: 768px) {
                width: auto;
            }
            .summary {
                font-size: 0.28rem;
                line-height: 1.2;
                margin-bottom: 0.9rem;
                @media screen and (max-width: 768px) {
                    font-size: 0.15rem;
                    margin-bottom: 0.24rem;
                }
            }
            .ul {
                @media screen and (max-width: 768px) {
                    width: 6.6rem;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                }
                .li {
                    @media screen and (max-width: 768px) {
                        width: 3.3rem;
                        padding-right: 0.45rem;
                        box-sizing: border-box;
                    }
                    .t0 {
                        font-size: 0.29rem;
                        line-height: 1.2;
                        font-weight: 700;
                        @media screen and (max-width: 768px) {
                            font-size: 0.15rem;
                        }
                        .circle {
                            padding-right: 0.15rem;
                            @media screen and (max-width: 768px) {
                                padding-right: 0.06rem;
                            }
                        }
                    }
                    .t1 {
                        line-height: 2;
                        font-size: 0.24rem;
                        margin: 0.2rem 0 0.9rem 0;
                        @media screen and (max-width: 768px) {
                            font-size: 0.12rem;
                            margin: 0.05rem 0 0.3rem 0;
                        }
                    }
                }
            }
        }
        .rightcon {
            width: 6.5rem;
            padding-top: 1.5rem;
            @media screen and (max-width: 768px) {
                width: auto;
                padding-top: 0rem;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
            .btxt {
                width: 7.49rem;
                height: 3.9rem;
                margin: 0 auto;
                .img {
                    width: 100%;
                    height: 100%;
                    display: block;
                    object-fit: contain;
                }
                @media screen and (max-width: 768px) {
                    width: 2.5rem;
                    height: 1.31rem;
                    margin: 0;
                }
            }
            .desc {
                font-size: 0.29rem;
                line-height: 1.5;
                text-align: justify;
                @media screen and (max-width: 768px) {
                    width: 3.5rem;
                    font-size: 0.12rem;
                    padding-top: 0.16rem;
                }
            }
        }
    }
    .page11 {
        background-color: #fff;
        padding: 0.6rem 0 0.6rem 0;
        @media screen and (max-width: 768px) {
            padding: 0.3rem 0 0.3rem 0;
        }
        .title {
            font-size: 0.61rem;
            font-weight: bold;
            text-align: center;
            margin-bottom: 0.4rem;
            color: #e60012;
            line-height: 1.2;
            @media screen and (max-width: 768px) {
                font-size: 0.43rem;
                margin-bottom: 0.2rem;
            }
        }
        .img10 {
            width: 15.49rem;
            margin: 0 auto;
            .img {
                width: 100%;
                display: block;
            }
            @media screen and (max-width: 768px) {
                width: 6.23rem;
            }
        }
    }
}
</style>
